import React from 'react';

const SHOW_UNTIL = new Date('2027-01-31T23:59:59');

export const NewBadge = ({ className = '', testId }) => {
  if (new Date() > SHOW_UNTIL) return null;
  return (
    <span className={`inline-flex items-center rounded-full bg-amber-400 text-amber-950 text-[10px] font-extrabold tracking-wider px-1.5 py-0.5 leading-none animate-pulse ${className}`} data-testid={testId || 'new-badge'}>
      NEW
    </span>
  );
};

export default NewBadge;
